const colors = {
  color: {
    primary: {
      primary: "#5563F5",
      primaryPressed: "#1021CB",
      primaryHover: "#3547FD",
      secondary: "#57E4F8",
      tertiary: "#171D41",
      stock: "#1C1E26"
    },
    secondary: {
      primaryTintPrimary: "#8791F8",
      primaryAccentTintPrimary: "#89ECFA",
      secondary: "#F5E755",
      secondaryShade: "#E5D41E",
      secondaryTint: "#FCF8CF",
      primaryTintSecondary: "#B7BDFB",
      primaryTintTertiary: "#E7E9FE",
      primaryAccentTintTertiary: "#EBFCFE",
      primaryAccentTintSecondary: "#BAF4FC",
    }
  },
  font: {
    lightBg: {
      primary: "#1C1E26",
      secondary: "#383940",
      tertiary: "#767B85",
    },
    darkBg: {
      primary: "#FFFFFF",
      secondary: "#E0E0E0",
      tertiary: "#A5A5A6",
    }
  },
  sematics: {
    lightBg: {
      success: "#00722A",
      successTint: "#E7F7E9",
      error: "#CE293A",
      errorTint: "#FFEBEA",
      warningMajor: "#F27818",
      warningMajorTint: "#FFEBDD",
      warningMinor: "#F3C423",
      warningMinorTint: "#FFF4CB",
      info: "#0075C8",
      infoTint: "#E8F3FE",
    }
  },
  neutrals: {
    lightBg: {
      primary: "#FFFFFF",
      secondary: "#F6F6F5",
      tertiary: "#EDEDED",
      quartary: "#E3E3E3",
      quinary: "#CCCCCC",
    }
  }

};


export default colors;